import { Component, Input } from "@angular/core";
import { PropertyPicturesService } from "../../../../project-valuation/services/property-pictures.service";

/**
 * Infobar (sidebar) that displays and handles actions to add/remove property images
 */
@Component({
  selector: 'comparables-property-infobar-pictures',
  templateUrl: './comparables-property-infobar-pictures.component.html'
})
export class ComparablesPropertyInfobarPicturesComponent {

  /**
  * Input property data.
  */
  @Input() data: any;

  /**
  * Required roles
  */
  requiredRoles: string[] = ['HasRole'];

  /**
  * Reflist name
  */
  reflistName = 'ref_property_imagetype';

  /**
  * Default new image type
  */
  defaultNewImageType = 0;

  /**
  * Constructor
  */
  constructor(public propertyPicturesService: PropertyPicturesService) { }
}
